import React, { memo } from 'react';
import { Trans } from 'react-i18next';
import { useRouter } from 'next/router';
import { Else, If, Then } from '@buyhatke/react-ui';

import { Link, Tx } from '@components';
import CLazyImg from '@components/LazyImage';

import { getAppLinkFromCountry, getCountryProps } from '@utils/params';

import facebook from '@img/v2/fb.svg';
import twitter from '@img/v2/twitter.svg';
import insta from '@img/v2/insta.svg';
// import linkedin from '@img/v2/linkedin.svg';
import reddit from '@img/v2/reddit.svg';
import telegramAnnounce from '@img/v2/telegram_announcement.svg';
import medium from '@img/v2/medium.svg';
import telegram from '@img/v2/telegram.svg';
import youtube from '@img/v2/youtube.svg';
import footer_pattern from '@img/v2/footer-pattern.svg';
import CoinGecko from '@img/v2/coinGeckoLogoWhite.svg';

const CFooter = ({ minimal }) => {
	const { asPath } = useRouter();

	const country = asPath.split('/')[1];
	let countryProps = {};
	if (country) {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		countryProps = getCountryProps(country) || {};
	}

	const countryParam = country
		? `?country=${country}&utm_source=bitbns&utm_medium=web_footer`
		: '?utm_source=bitbns&utm_medium=web_footer';
	const {
		bns: { ios, android },
	} = getAppLinkFromCountry(country);

	const isTr = asPath === '/tr' || asPath.startsWith('/tr/');

	return (
		<>
			<If condition={isTr}>
				<Then>
					<div className="bg-lavender text-sm md:text-base py-10">
						<div className="container">
							<div className="">
								<p>
									<Tx tx="bnsTurkey" />
								</p>
								<p className="my-4">
									<Tx tx="footer.disclaimerNStuffs.address" />
								</p>
								<p className="my-4">
									<Tx tx="footer.disclaimerNStuffs.para" />
								</p>
								{/* <div className="flex items-center justify-center md:justify-start"> */}
							</div>
						</div>
					</div>
				</Then>
			</If>
			<div className="c-footer bg-primary">
				{!minimal && (
					<div className="container grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3">
						<div>
							<div className="c-ftrCol__heading">
								<Tx tx="footer.company" />
							</div>
							<div className="c-ftrCol__contents c-ftrCol__contents--withLinks">
								<Link href="/about-us/">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="footer.aboutUs" />
									</a>
								</Link>
								{/* <a
							className="c-links w-fitContent c-links--light"
							href="https://affiliate.bitbns.com/dashboard/#/"
						>
							Affiliates
						</a> */}
								{/* <Link

							href="/p2p-fiat-crypto-api-integration-documentation/"
						>
							Bitbns P2P Integration API
						</Link> */}
								<a
									className="c-links w-fitContent c-links--light"
									href="https://bitbns.freshdesk.com"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Tx tx="footer.bitbnsFaQs" />
								</a>
								<Link href="/faq/">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="footer.moreFaQs" />
									</a>
								</Link>
								<Link href="/bug-bounty/">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="footer.bugBounty" />
									</a>
								</Link>
								<Link href="/fees/">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="footer.fees" />
									</a>
								</Link>
								<Link href="/refer-and-earn/">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="footer.referralProgram" />
									</a>
								</Link>
								<Link href="/how-it-works/">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="footer.howItWorks" />
									</a>
								</Link>
							</div>
						</div>
						<div>
							<div className="c-ftrCol__heading">
								<Tx tx="footer.products" />
							</div>
							<div className="c-ftrCol__contents c-ftrCol__contents--withLinks">
								<a
									className="c-links w-fitContent c-links--white"
									target="_blank"
									rel="nofollow noopener noreferrer"
									href="https://bitdroplet.com/?utm_source=bitbns&utm_medium=web_footer"
								>
									<Tx tx="Bitdroplet" />
								</a>
								<a
									className="c-links w-fitContent c-links--white"
									target="_blank"
									rel="nofollow noopener noreferrer"
									href="http://launchonascent.com/?utm_source=bitbns&utm_medium=web_footer"
								>
									<Tx tx="Ascent" />
								</a>
								<a
									className="c-links w-fitContent c-links--white"
									target="_blank"
									rel="nofollow noopener noreferrer"
									href={`/trade/${countryParam}#/fixed-deposits`}
								>
									<Tx tx="Fixed Deposits" />
								</a>
								<a
									className="c-links w-fitContent c-links--white"
									target="_blank"
									rel="nofollow noopener noreferrer"
									href="https://learn.bitbns.com?utm_source=bitbns&utm_medium=web_footer"
								>
									<Tx tx="bitbnsAcademy" />
								</a>
								<a
									className="c-links c-links--white"
									target="_blank"
									rel="noopener noreferrer"
									href="https://shop.bitbns.com?utm_source=bitbns&utm_medium=web_footer"
								>
									<Tx tx="footer.buyBitbnsMerchandise" />
								</a>
							</div>

							<div className="c-ftrCol__heading">
								<Tx tx="footer.usefulLinks.title" />
							</div>
							<div className="c-ftrCol__contents c-ftrCol__contents--withLinks">
								<a
									className="c-links w-fitContent font-normal c-links--white"
									href={`/trade/${countryParam}`}
									rel="noopener noreferrer"
								>
									<Tx
										tx="footer.usefulLinks.coinToCurr"
										values={{
											coin: 'BTC',
											curr: isTr ? 'TRY' : 'INR',
										}}
									/>
								</a>
								<a
									className="c-links w-fitContent font-normal c-links--white"
									href="https://bitdroplet.com"
									rel="noopener noreferrer"
								>
									<Tx
										tx="footer.usefulLinks.sipInCoin"
										values={{
											coin: 'Bitcoin',
										}}
									/>
								</a>
								<Link href="/buy-bitcoin-in-uae-dubai/">
									<a className="c-links w-fitContent c-links--light">
										<Tx
											tx="footer.usefulLinks.buyCoinWithCurr"
											values={{
												coin: 'Bitcoin',
												curr: 'AED',
											}}
										/>
									</a>
								</Link>
								<Link href="/ripple-price-usd/">
									<a className="c-links w-fitContent c-links--light">
										<Tx
											tx="footer.usefulLinks.coinPriceCurr"
											values={{
												coin: 'Ripple',
												curr: 'USD',
											}}
										/>
									</a>
								</Link>
								<Link href="/bitcoin-price-usd/">
									<a className="c-links w-fitContent c-links--light">
										<Tx
											tx="footer.usefulLinks.coinToCurr"
											values={{
												coin: 'Bitcoin',
												curr: 'USD',
											}}
										/>
									</a>
								</Link>
								<Link href="/eos-ram-price-usd/">
									<a className="c-links w-fitContent c-links--light">
										<Tx
											tx="footer.usefulLinks.coinPriceInCurr"
											values={{
												coin: 'EOS RAM',
												curr: 'USD',
											}}
										/>
									</a>
								</Link>
								<a
									className="c-links w-fitContent font-normal c-links--white"
									href="https://bitbns.com/bitcoinwhitepaper.pdf"
									rel="noopener noreferrer"
									target="_blank"
								>
									<Tx tx="footer.usefulLinks.btcWhitepaper" />
								</a>
							</div>
						</div>
						<div>
							<div className="c-ftrCol__heading">
								<Tx tx="footer.services.title" />
							</div>
							<div className="c-ftrCol__contents c-ftrCol__contents--withLinks">
								<a
									className="c-links w-fitContent font-normal c-links--white"
									href="/bns/"
									rel="noopener noreferrer"
								>
									BNS
								</a>
								<Link href="/trade-mechanism/">
									<a className="c-links w-fitContent font-normal c-links--white">
										<Tx tx="footer.services.tradingMechanism" />
									</a>
								</Link>
								<If condition={countryProps.noMargin}>
									<Else>
										<a
											className="c-links w-fitContent c-links--light"
											target="_blank"
											rel="noopener noreferrer"
											href="https://goo.gl/KJtJyr"
										>
											<Tx tx="marginTrading" />
										</a>
									</Else>
								</If>
								<a
									className="c-links w-fitContent c-links--light"
									target="_blank"
									rel="noopener noreferrer"
									href={`/trade/${countryParam}#/api-trading/`}
								>
									<Tx tx="apiTrading" />
								</a>
								<a
									className="c-links w-fitContent c-links--light"
									target="_blank"
									rel="noopener noreferrer"
									href="https://bitbns.com/order/getTickerWithVolume/"
								>
									<Tx tx="footer.services.tickerApi" />
								</a>
								<a
									className="c-links w-fitContent font-normal c-links--white"
									href={`/trade/${countryParam}#/node-status/`}
									rel="noopener noreferrer"
								>
									<Tx tx="nodeStatus" />
								</a>

								<Link href="/cryptocurrency-stop-limit-order-with-trail/">
									<a className="c-links w-fitContent font-normal c-links--white">
										<Tx tx="footer.services.stopLimit" />
									</a>
								</Link>
								<a
									className="c-links w-fitContent c-links--light"
									href="https://chrome.google.com/webstore/detail/bitbns-extension/chohglfmmlfhnkloampcdmnnhnhegbfg?hl=en"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Tx tx="footer.services.arbExtChrome" />
								</a>
								<a
									className="c-links w-fitContent c-links--light"
									href="https://addons.mozilla.org/en-US/firefox/addon/bitbns-extension/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Tx tx="footer.services.arbExtFirefox" />
								</a>
								<a
									className="c-links w-fitContent c-links--light"
									href="https://microsoftedge.microsoft.com/addons/detail/henknmclfminihnoikcbpggjoofiiafc"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Tx tx="footer.services.arbExtEdge" />
								</a>
								<a
									className="c-links w-fitContent c-links--light"
									href="https://api.elasticemail.com/contact/subscribe?version=2&pID=d46fa7aa-05a9-452f-915b-676d3c0f86fe"
									target="_blank"
									rel="noreferrer noopener nofollow"
								>
									<Tx tx="notReceivingEmail" />
								</a>
							</div>
						</div>
						<div>
							<div className="c-ftrCol__heading">
								<Tx tx="contactUs" />
							</div>
							<div className="c-ftrCol__contents c-ftrCol__contents--withLinks">
								<Link href="/contact-us">
									<a className="c-links w-fitContent c-links--light">
										<Tx tx="customerSupport" />
									</a>
								</Link>
								<a
									className="c-links font-normal c-links--white"
									href="mailto:listing@bitbns.com"
									target="_blank"
									rel="noreferrer noopener noopener"
								>
									<Tx tx="projectListing" />
								</a>
							</div>

							<div className="c-ftrCol__heading">
								<Tx tx="footer.socialMedia.title" />
							</div>
							<div className="c-ftrCol__contents">
								<div className="flex items-center my-8">
									<a
										className="c-links w-fitContent c-links--white mx-3 ml-0 md:mx-5 md:ml-0"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://www.facebook.com/bitbns/"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img
											src={facebook.src}
											alt="facebook"
										/>
									</a>
									<a
										className="c-links w-fitContent c-links--white mx-3 md:mx-5"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://twitter.com/bitbns/"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img src={twitter.src} alt="twitter" />
									</a>
									<a
										className="c-links w-fitContent c-links--white mx-3 md:mx-5"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://www.instagram.com/bitbns/"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img src={insta.src} alt="insta" />
									</a>
									<a
										className="c-links w-fitContent c-links--white mx-3 md:mx-5"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://t.me/Bitbns"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img
											src={telegram.src}
											alt="telegram"
										/>
									</a>
								</div>
								<div className="flex items-center my-6">
									<a
										className="c-links w-fitContent c-links--white mx-3 ml-0 md:mx-5 md:ml-0"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://www.youtube.com/c/Bitbns?sub_confirmation=1"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img src={youtube.src} alt="youtube" />
									</a>

									<a
										className="c-links c-links--white mx-3 md:mx-5"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://t.me/bitbnsannouncements"
									>
										<img
											/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
											src={telegramAnnounce.src}
											alt="telegram Announcement"
										/>
									</a>

									<a
										className="c-links w-fitContent c-links--white mx-3 md:mx-5"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://medium.com/bitbns"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img src={medium.src} alt="medium" />
									</a>
									<a
										className="c-links w-fitContent c-links--white mx-3 md:mx-5"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://www.coingecko.com/en/exchanges/bitbns"
										title="CoinGecko"
									>
										<img
											/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
											src={CoinGecko.src}
											alt="CoinGecko"
											width="20"
											height="20"
										/>
									</a>
									{/* <a
								className="c-links w-fitContent c-links--white mx-3 md:mx-5"
								target="_blank"
								rel="nofollow noopener noreferrer"
								href="https://www.linkedin.com/company/bitbnsinc/"
							>
								<img src={linkedin.src} alt="linkedin" />
							</a> */}
								</div>
								<div className="flex items-center my-6">
									<a
										className="c-links w-fitContent c-links--white mx-3 ml-0 md:mx-5 md:ml-0"
										target="_blank"
										rel="nofollow noopener noreferrer"
										href="https://www.reddit.com/r/Bitbns/"
									>
										{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
										<img src={reddit.src} alt="reddit" />
									</a>
									{/* <div className="flex items-center my-6"></div> */}
								</div>
								{/* <div className="flex items-center my-6">

						</div> */}
							</div>
							{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
							<img
								src="https://bitbns.com/assets/img/appIcons/svg/iso27001.svg"
								alt="Iso27001"
								className="mt-12"
							/>
						</div>
					</div>
				)}
				<div className="container c-ftr__disclaimer my-10 flex items-center flex-wrap flex-row text-white">
					<div className="mr-4 u-text--singleLine mb-4 opacity-50">
						<Tx tx="footer.dloadApp" />
					</div>
					<div>
						<a
							href={`${android}&referrer=utm_source%3DbitbnsTradeFtr%26utm_medium%3Dwebsite`}
							target="_blank"
							rel="noreferrer noopener"
						>
							<CLazyImg
								src="https://bitbns.com/assets/img/google-play-badge.svg"
								alt="Google Play"
								height="40"
								width="128"
								className="mr-4 inline-block"
							/>
						</a>
						<a href={ios} target="_blank" rel="noreferrer noopener">
							<CLazyImg
								src="https://bitbns.com/assets/img/app-store-badge.svg"
								alt="Apple App Store"
								height="40"
								width="128"
								className="inline-block"
							/>
						</a>
					</div>
				</div>
				<div className="container relative c-ftr__disclaimer text-white opacity-50 my-8">
					<Trans i18nKey="footer.disclaimer">
						<b>Disclaimer:</b> Trading in cryptocurrencies are
						subject to market, technical and legal risks.
						<p>
							The prices fluctuate based on local demand and
							supply.
						</p>
					</Trans>
					<br />
					&copy;{new Date().getFullYear()} Bitbns.com. All rights
					reserved
					<span className="mx-5">|</span>
					<Link
						href={
							isTr
								? '/tr/terms-of-use/'
								: '/terms-and-conditions/'
						}
					>
						<a className="c-links w-fitContent c-links--white">
							<Tx tx="footer.termsOfService" />
						</a>
					</Link>
					<span className="mx-5">|</span>
					<Link
						href={isTr ? '/tr/privacy-policy/' : '/privacy-policy/'}
					>
						<a className="c-links w-fitContent c-links--white">
							<Tx tx="footer.privacyPolicy" />
						</a>
					</Link>
					<If condition={isTr}>
						<Then>
							<span className="mx-5">|</span>
							<Link href="/tr/explicit-consent/">
								<a className="c-links w-fitContent c-links--white">
									<Tx tx="footer.explicitConsent" />
								</a>
							</Link>
						</Then>
					</If>
					{minimal && (
						<>
							<span className="mx-5">|</span>
							<Link href="/fees/">
								<a className="c-links w-fitContent c-links--white">
									<Tx tx="Fees" />
								</a>
							</Link>
						</>
					)}
					{minimal && (
						<div className="text-lavender mt-4 text-xs">
							Bitbns OÜ., a cryptocurrency exchange firm licensed
							and supervised by the Tartu County Court
							Registration Department under registry code 14718244
						</div>
					)}
					<img
						/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
						src={footer_pattern.src}
						alt="footer pattern"
						className="absolute right-0 mr-20 top-0 hidden md:inline-block"
					/>
				</div>
			</div>
		</>
	);
};

export default memo(CFooter);
